import { Outlet, useNavigate } from "react-router-dom";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import TranslationScope from "../../translation/translation-scope";
import { observer } from "mobx-react";
import coverageSettingsStore from "./stores/coverage-settings-store";
import { useEffect } from "react";
import { PageLoader } from "../../components/page-loader/page-loader";

const CoverageSettingsPage: React.FC = observer(() => {
    /** COMMENTED OUT DUE TO LACK OF PERMISSION SCOPE FOR read_themes - see also in App.tsx
     * see closed task https://returngo.atlassian.net/browse/RD-8411
     * 
    const navigate = useNavigate();
    const store = coverageSettingsStore;

    useEffect(() => {
        store.loadExtensionData();
    }, [store]);

    useEffect(() => {
        if (store.isShopifyExtensionEnabled) {
            navigate('coverage-settings-enabled');
        }
    }, [navigate, store.isShopifyExtensionEnabled]);

    if (!store.isLoadedhopifyExtensionData) {
        return <PageLoader />;
    }
    */

    const navigate = useNavigate();
    const store = coverageSettingsStore;

    useEffect(() => {
        const load = async() => {
            await store.load();
            if (store.shouldShowCoverageSettingsPage) {
                navigate('coverage-settings-enabled');
            }
        }
        load()
    }, [navigate, store, store.shouldShowCoverageSettingsPage]);

    /** As long as we don't know which page to render, we show loader */
    if (store.shouldShowCoverageSettingsPage === undefined) {
        return <PageLoader />;
    }

    return (
        <BasePageLayout title="Return Guard">
            <TranslationScope scope="assistant">
                <div className="coverage-settings-page">
                    <Outlet />
                </div>
            </TranslationScope>
        </BasePageLayout>
    );
});

export default CoverageSettingsPage;